module.exports = __webpack_public_path__ + "static/media/getFetch.013f0b90.cjs";